import React, { useState, useEffect } from "react";
import { Form } from "react-bootstrap";
import { AppModal, AppButton } from "../ui";

const emptyTestCase = { input: "", expectedOutput: "", isHidden: false };

const TestCaseForm = ({ show, onHide, onSave, testCase }) => {
  const [form, setForm] = useState(emptyTestCase);

  useEffect(() => {
    if (testCase) setForm(testCase);
    else setForm(emptyTestCase);
  }, [testCase, show]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(form);
  };

  return (
    <AppModal
      show={show}
      onHide={onHide}
      size="sm"
      title={testCase ? "Edit Test Case" : "Add Test Case"}
      closeOnOverlay={false}
      footer={
        <div style={{ display: "flex", gap: "0.5rem", justifyContent: "flex-end" }}>
          <AppButton variant="outline" type="button" onClick={onHide}>
            Cancel
          </AppButton>
          <AppButton type="submit" form="test-case-form">
            {testCase ? "Save Changes" : "Add Test Case"}
          </AppButton>
        </div>
      }
    >
      <Form id="test-case-form" onSubmit={handleSubmit}>
        <Form.Group className="mb-3">
          <Form.Label>Input</Form.Label>
          <Form.Control
            as="textarea"
            rows={2}
            name="input"
            value={form.input}
            onChange={handleChange}
            required
            placeholder="Test input"
          />
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>Expected Output</Form.Label>
          <Form.Control
            as="textarea"
            rows={2}
            name="expectedOutput"
            value={form.expectedOutput}
            onChange={handleChange}
            required
            placeholder="Expected output"
          />
        </Form.Group>
        <Form.Group className="mb-1" controlId="isHidden">
          <Form.Check
            type="checkbox"
            label="Hidden (for evaluation only, not visible to student)"
            name="isHidden"
            checked={form.isHidden}
            onChange={handleChange}
          />
        </Form.Group>
      </Form>
    </AppModal>
  );
};

export default TestCaseForm;
